require('./prtv-interface-6.scss');

import DemandeActions from '../../../../actions/demande.actions';
import { STEPS } from '../../../../utils/routes.util';

export default class PrtvInterface6Component {
  constructor() {
    this.controller = PrtvInterface6Controller;
    this.template = require('./prtv-interface-6.html');
  }
}

// @ngInject
class PrtvInterface6Controller {

  constructor($scope, $ngRedux) {
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.data = {};
  }

  $onInit() {
    // Demande de récupération de la demande avant connexion au state
    this.$ngRedux.dispatch(DemandeActions.loadDemande(STEPS.PRTV_INTERFACE_6));

    // Connexion au state récupérer les données modifiées
    const disconnect = this.$ngRedux.connect(
      state => {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          demande: state.demande.data,
          data: state.demande.data.prtvInterface6 ? state.demande.data.prtvInterface6.asMutable({deep: true}) : this.data,
          demandeEnquetePapier: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.demandeEnquetePapier :
            state.demande.data.demandeEnquete ? state.demande.data.demandeEnquete : false,
          typePersonne: state.demande.data.typePersonne ? state.demande.data.typePersonne : '',
          nom: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.nom :
            state.demande.data.suivieAuthent ? state.demande.data.suivieAuthent.nom : '',
          prenom: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.prenom :
            state.demande.data.suivieAuthent ? state.demande.data.suivieAuthent.prenom : '',
        };
      }
    )(this);
    // Déconnexion du state à la suppression du composant
    this.$scope.$on('$destroy', disconnect);
    this.disableNext = true;
  }

  // Actions
  nextStep() {
    this.data.nom = this.nom;
    this.data.prenom = this.prenom;
    this.$ngRedux.dispatch(DemandeActions.updatePrtv6ToFacture(this.data));
  }
}



// WEBPACK FOOTER //
// ./src/modules/prtv/components/prtv-interface-6/prtv-interface-6.component.js